import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { Logger } from './app/helper/logger';

if (environment.production) {
  Logger.configure({
    env: 'production',
    prodWhitelist: [],  // only show AuthService logs in prod
  });
} else {
  Logger.configure({
    env: 'development',
    whitelist: undefined, // ['app.config','authService','AppComponent'],
    enabled: true,
  });
}// 
// 'PriceStockComponent','ListingService','SearchComponent','AccountService', 'CategorySingleSelector'
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
